// Small filled circle/square/star icon used in the keypoint roster rows and
// the on-screen legend, so the panel mirrors the canvas markers (spec table).

import type * as React from 'react';
import type { KeypointShape } from '../config/constants';
import { starPoints } from '../lib/shapes';

export interface KeypointShapeIconProps {
  shape: KeypointShape;
  color: string;
  size?: number;
  className?: string;
}

export function KeypointShapeIcon({
  shape,
  color,
  size = 12,
  className,
}: KeypointShapeIconProps): React.ReactElement {
  const c = size / 2;
  const r = size / 2;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      aria-hidden
      role="presentation"
    >
      {shape === 'circle' && <circle cx={c} cy={c} r={r} fill={color} />}
      {shape === 'square' && <rect x={0} y={0} width={size} height={size} fill={color} />}
      {shape === 'star' && <polygon points={starPoints(c, c, r)} fill={color} />}
    </svg>
  );
}
